module.exports = __webpack_public_path__ + "media/images/payment_methods/przelewy24-9dff65a76d7b946499b7b56dbbe9526c.svg";